"use strict";

exports.__esModule = true;
var _CreateTicketActionElement = require("./CreateTicketActionElement");
Object.keys(_CreateTicketActionElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateTicketActionElement[key]) return;
  exports[key] = _CreateTicketActionElement[key];
});
var _CreateTicketActionDialog = require("./CreateTicketActionDialog");
Object.keys(_CreateTicketActionDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateTicketActionDialog[key]) return;
  exports[key] = _CreateTicketActionDialog[key];
});
var _action = require("./action");
Object.keys(_action).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _action[key]) return;
  exports[key] = _action[key];
});